import React, { ReactNode } from "react";
import { CardActions as MuiCardActions } from "@mui/material";

interface CardActionsProps {
  children?: ReactNode;
  className?: string;
}

export const CardActions: React.FC<CardActionsProps> = ({
  children,
  className,
}: CardActionsProps) => {
  return (
    <MuiCardActions className={`card__actions-container ${className}`}>
      {children}
    </MuiCardActions>
  );
};
